import PromisePayCom from "~/common/components/dialog/payDialog/PromisePay.vue";
import store from '~/store/index'
import router from '~/router/router'
import i18n from '~/common/plugins/i18n.js';

const promisePayDialog = {
  install(Vue) {
    const FullNameInstance = Vue.extend({
      template: `
        <PromisePayCom
          class="direct-order-payment"
          :paymentData="source"
          :paymentVisible="flag"
          @hide="hide"
        ></PromisePayCom>
      `,
      components: { PromisePayCom },
      props: ['visible', 'datas','emits'],
      data() {
        return {
          flag: false,
          source: {}
        }
      },
      created() {
        this.flag = this.visible
        this.source = this.datas
      },
      methods: {
        hide(data) {
          this.flag = false
          this.emits('hide',data)
        },
      }
    });

    Vue.prototype.$promisePay = (option) => {
      if(process.client) {
        const bodyChilds = document.body.children;
        const [page1, page2] = Array.from(bodyChilds).reduce(
          (acc, item) => {
            if (item.classList.contains('direct-order-payment')) {
              acc[0].push(item);
            }  else if (item.classList.contains('el-dialog__wrapper') && item.querySelector('.promise-pay')) {
              acc[1].push(item);
            }
            return acc;
          },
          [[], [], []]
        );

        [...page1, ...page2].forEach(item => document.body.removeChild(item));
      }

      let instance = new FullNameInstance({
        propsData: {
          ...option
        },
        store,
        router,
        i18n
      });

      let nameSpan = instance.$mount().$el;
      document.body.appendChild(nameSpan);

      instance.remove = function () {
        document.body.removeChild(instance.$el);
        instance.$destroy()
      }
      // 返回实例，以便外部可以调用remove方法
      return instance;
    }
  }
}

export default promisePayDialog;
